module.exports = __webpack_public_path__ + "static/media/LogoBossabox.4f3c0eda.svg";